import Backbone from "backbone";
import sleep from "nx-components/utils/sleep";
import Collection from "nexia_mobile/framework/collection";
import BaseModel from "nexia_mobile/models/base_model";
import Resource from "nexia_mobile/framework/resource";
import Editable from "nexia_mobile/models/mixins/editable";

class BaseCollection extends Collection {
  parse(rawAttrs, ...args) {
    let attrs = super.parse(rawAttrs, ...args);

    let items = this._performParseSideEffects(attrs);
    if (!items) {
      // If the server hasn't given us any items, we can't
      // assume there are NO items, just that we haven't been given them.
      // (Server gives an empty array of items if there were none).
      // In this case, instead of returning an empty array (which
      // would remove all items in the collection), return the same
      // models that we currently have- this effectively no-ops the set
      // operation, but ensures the parse still goes through (because our
      // models all depend on parse running).
      return this.models;
    }

    let ModelClass = this.model || BaseModel;
    return items.map((item) => {
      if (item instanceof Backbone.Model) {
        return item;
      } else {
        return new ModelClass(item, { parse: true });
      }
    });
  }

  async _parseModelsAsync(rawAttrs, options, ...args) {
    let attrs = await super._parseModelsAsync(rawAttrs, options, ...args);
    let items = this._performParseSideEffects(attrs);
    if (!items) {
      return this.models;
    }

    let ModelClass = this.model || BaseModel;
    let models = [];
    for (let item of items) {
      if (item instanceof Backbone.Model) {
        models.push(item);
      } else {
        await sleep(options.asyncParseDelay);
        let model = new ModelClass(item, { parse: true });
        models.push(model);
      }
    }
    return models;
  }

  _performParseSideEffects(attributes) {
    let attrs = attributes;
    if (attrs.result) {
      attrs = attrs.result;
    }

    _.extend(attrs, this.parseLinks(attrs));

    if (attrs.template) {
      this._createSchemaFromAttrs(attrs.template);
    }

    let items;
    if (_.isArray(attrs)) {
      items = attrs;
    } else if (_.isArray(attrs.items)) {
      items = attrs.items;
    }
    return items;
  }

  trigger(...args) {
    super.trigger(...args);
    // only broadcast the event if we were the originator.
    // otherwise events bubbled up from models within this collection will get repeated
    if (args[1] === this) {
      BaseModel.Events.trigger(...args);
    }
  }
}

_.extend(BaseCollection.prototype, Editable);
_.extend(BaseCollection.prototype, Resource);
BaseCollection.prototype.model = BaseModel;

export default BaseCollection;



// WEBPACK FOOTER //
// ./src/models/base_collection.js